
    import Vue from 'vue'
    import { Component, Prop, Watch } from 'vue-property-decorator';
    import RepsolFilterBarComponent from '@/components/repsol-filter-bar/RepsolFilterBarComponent.vue';
    import RepsolFilterChipsComponent from '@/components/repsol-filter-chips/RepsolFilterChipsComponent.vue';
    import RepsolTableComponent from '@/components/repsol-table/RepsolTableComponent.vue';
    import RepsolFormPopupComponent from '@/components/repsol-form-popup/RepsolFormPopupComponent.vue'
    import { Chip, FormFields, FilterFields, TableHeaderModel, SelectModel, MaestroEstrategia, CrearEstrategiasOperaciones } from  '@/models/repsol-template.model';
    import moment from 'moment';
    import RepsolImportComponent from '@/components/repsol-import/RepsolImportComponent.vue';
    import store from '@/store';
    import { UserIdentityModel } from '@/models/file-entities.model';
    import ComponentBase from '@/mixins/componentBase';
import { ImportLabels } from '@/models/repsol-template-aggregate.model';


    @Component({
        name: 'OperacionesPage',
        components: {
            RepsolFilterBarComponent,
            RepsolFilterChipsComponent,
            RepsolTableComponent,
            RepsolFormPopupComponent,
            RepsolImportComponent
        },
    })

    class OperacionesPage extends ComponentBase {
        @Prop()
        historico :boolean;
        @Watch('historico')
        cambioHistorico(){
            this.isLoad = false;
            this.isLoad = true;
            // this.getOperacionesList();
        }
        isLoad = false;
        isOpenFilters = false;
        isOpenForm = false;
        formIsValid = true;
        formOnlyRead = false;
        isContraParte = false;
        isAdminCEN = false;
        isMesaLect = false;

        fechaEjecucionAnterior = null;
        productoAnterior = null;
        mesaAnterior = null;

        isOpenImportar = false;

        deleteFilter = "";

        popupHeaderText = "";

        configuracion:ImportLabels[] = [
            {label: 'operaciones.total', campo: 'total', error: false, ocultarCeroVacio: true},
            {label: 'operaciones.creados', campo: 'creados', error: false, ocultarCeroVacio: true},
            {label: 'operaciones.actualizados', campo: 'actualizados', error: false, ocultarCeroVacio: true},
            {label: 'operaciones.eliminados', campo: 'eliminados', error: false, ocultarCeroVacio: true},
            {label: 'operaciones.totalErrores', campo: 'totalErrores', error: true, ocultarCeroVacio: true},
            {label: 'operaciones.errores', campo: 'errores', error: true, ocultarCeroVacio: true, table:[
                { text: 'operaciones.linea_col', value: "linea", sortable: false },
                { text: 'operaciones.tipo_col', value: "tipo", sortable: false },
                { text: 'operaciones.error_col', value: "error", sortable: false },
            ]},
        ];

        filterChips:Chip[] = [];

        mesas: SelectModel[] = [];

        filterMesa : FilterFields;

        filterFields : FilterFields[] = [];

        formFields : FormFields[] = [];

        items:any[] = [];

        itemEdit:any = {};

        mesaHeader : TableHeaderModel ;
        tableHeaders:TableHeaderModel[] = [];

        itemEliminar: any = {};
        crearEstrategiaOperacion: CrearEstrategiasOperaciones = {idEstrategia: 0, crearDiarias: true};

        showDialog = false;

        showWarning = false;

        tableLoading = false;
        totalItems = 0;

        tableOptions = {
        page: 1,
        itemsPerPage: 10,
        sortBy: [] as string[],
        sortDesc: [] as boolean[],
    };

        constructor() {
            super();
        }

        t(message: string, params?: Record<string, unknown>): string {
            return this.$t(message, params).toString();
        }

        mesaFormField:FormFields;
        lineaFormField:FormFields;

       async mounted(){
            //this.getOperacionesList();
            this.getMaestroProducto();
            this.getMaestroCierreEstado();
            this.getMaestroConsolidadoNeteoDetalleEjecucionTipo();
            this.getMaestroOperacionEstado();
            this.getMaestroOperacionTipo();
            this.getMaestroMesa();
            this.getMaestroEstrategia();
            const userIdentity = (store.state as any).userIdentity.userIdentity as UserIdentityModel;
            this.isAdminCEN = userIdentity.perfilId == 'CEN'
            this.isContraParte = userIdentity.perfilId == 'CONTR';
            this.isMesaLect = userIdentity.perfilId == 'MLECT'
            this.filterMesa = {
                label: 'operaciones.mesa',
                name: 'mesa',
                as: 'selectlist',
                model: [],
                isDisabled: false,
                isRequired: true,
                items: this.maestroMesaBase,
                multiple: true
            };
            this.mesaFormField =  {
                label: 'operaciones.mesa',
                name: 'mesaId',
                as: 'selectlist',
                model: '',
                isDisabled: false,
                isRequired: true,
                items: this.maestroMesaEscritura,
                multiple: false,
                canView: true,
                cols: 4
            };
        this.mesaHeader = { text: 'operaciones.mesa', value: "mesaId", sortable: true, as: 'multiselect', tooltip: true, items: this.maestroMesaBase};

            this.isContraParte ? this.loadContraperte() : this.loadNoContraparte();
            this.isLoad = true;
        }

       onTableOptionsChanged(options: any) {
        this.tableOptions = { ...options };
        this.getOperacionesList();
    }

        loadContraperte(): void
        {
                this.lineaFormField =  {
                    label: 'operaciones.linea',
                    name: 'linea',
                    as: 'selectlist',
                    model: '',
                    isDisabled: true,
                    isRequired: true,
                    items: this.maestrosLinea,
                    multiple: false,
                    canView: true,
                    cols: 3,
                };

            this.filterFields  =  [
                {
                    label: 'operaciones.estado',
                    name: 'estado',
                    as: 'selectlist',
                    model: [],
                    isDisabled: false,
                    isRequired: false,
                    items: this.maestroOperacionEstado,
                    multiple: true
                },
                {
                    label: 'operaciones.fecha_desde',
                    name: 'fechaDesde',
                    as: 'date',
                    model: '',
                    isDisabled: false,
                    isRequired: false
                },
                {
                    label: 'operaciones.fecha_hasta',
                    name: 'fechaHasta',
                    as: 'date',
                    model: '',
                    isDisabled: false,
                    isRequired: false
                }
            ];

            this.formFields  =  [
                {
                    label: 'operaciones.nombre_estrategia',
                    name: 'estrategiaId',
                    as: 'selectlist',
                    model: '',
                    isDisabled: false,
                    isRequired: true,
                    items: this.maestroEstrategiaEscritura,
                    multiple: false,
                    canView: true,
                    cols: 4,
                },
                {
                    label: 'operaciones.cantidad_lotes',
                    name: 'cantidad',
                    as: 'number',
                    model: '',
                    isDisabled: false,
                    isRequired: true,
                    canView: true,
                    cols: 4,
                },
                {
                    label: 'operaciones.fecha',
                    name: 'fechaEjecucion',
                    as: 'date',
                    model: '',
                    isDisabled: false,
                    isRequired: false,

                    multiple: true,
                    canView: true,
                    cols: 4,
                },
                {
                    label: 'operaciones.producto',
                    name: 'productoId',
                    as: 'selectlist',
                    model: '',
                    isDisabled: true,
                    isRequired: true,
                    items: this.maestroProductoEscritura,
                    multiple: false,
                    canView: true,
                    cols: 3,
                },
                {
                    label: 'operaciones.estrategia',
                    name: 'codigoEstrategia',
                    as: 'number',
                    model: '',
                    isDisabled: true,
                    isRequired: true,
                    canView: true,
                    cols: 3,
                },
                {
                    label: 'operaciones.tipo',
                    name: 'tipoId',
                    as: 'selectlist',
                    model: '',
                    isDisabled: true,
                    isRequired: true,
                    items: this.maestroOperacionTipo,
                    multiple: false,
                    canView: true,
                    cols: 3,
                },
                this.lineaFormField
            ];

            this.rulesForm["estrategiaId"] = [this.required()];
            this.rulesForm["cantidad"] = [this.minLen(1)];
            this.rulesForm["fechaEjecucion"] = [this.required()];

            this.tableHeaders = [
                { text: 'operaciones.identificador', value: "id", sortable: true, as:'number' },
                { text: 'operaciones.nombre_estrategia', value: "codigoEstrategia", sortable: true, as: 'multiselect',items: this.maestroEstrategiaBase },
                { text: 'operaciones.fecha', value: "fechaEjecucion", sortable: true, as: 'date' },
                { text: 'operaciones.cantidad_lotes', value: "cantidad", sortable: true, as: 'number' },
                { text: 'operaciones.estado', value: "estadoId", sortable: true, as: 'multiselect',
                    items: this.maestroOperacionEstado },
                { text: 'operaciones.producto', value: "productoId", sortable: true, as: 'multiselect', items: this.maestroProducto },
                { text: 'operaciones.tipo', value: "tipoId", sortable: true, as: 'multiselect',
                    items: this.maestroOperacionTipo },
                { text: 'operaciones.linea', value: "linea", sortable: true, as: 'select',
                    items: this.maestrosLinea},
                { text: 'operaciones.estrategia', value: "codigoEstrategia", sortable: true, as: 'multiselect' },
                { text: '', value: "actions", sortable: false, as:'', actions:[
                    {icon: 'mdi-close', name: 'eliminar'},
                    {icon: 'edit', name: 'editar'},
                    {icon: 'visibility', name: 'ver'}
                ]},
            ];
        }

        loadNoContraparte(): void{
            this.lineaFormField =  {
                label: 'operaciones.linea',
                name: 'linea',
                as: 'selectlist',
                model: '',
                isDisabled: true,
                isRequired: true,
                items: this.maestrosLinea,
                multiple: false,
                canView: true,
                cols: 3,
            };

            this.filterFields  =  []

            this.filterFields.push({
                label: 'operaciones.mesa',
                name: 'mesa',
                as: 'selectlist',
                model: [],
                isDisabled: false,
                isRequired: false,
                items: this.maestroMesaBase,
                multiple: true
            });

            this.filterFields.push({
                label: 'operaciones.estado',
                name: 'estado',
                as: 'selectlist',
                model: [],
                isDisabled: false,
                isRequired: false,
                items: this.maestroOperacionEstado,
                multiple: true
            });
            this.filterFields.push({
                label: 'operaciones.producto',
                name: 'productoId',
                as: 'selectlist',
                model: [],
                isDisabled: false,
                isRequired: false,
                items: this.maestroProductoEscritura,
                multiple: true
            });
            this.filterFields.push({
                label: 'operaciones.tipo',
                name: 'tipo',
                as: 'selectlist',
                model: '',
                isDisabled: false,
                isRequired: false,
                items: this.maestroOperacionTipo,
                multiple: false
            });
            this.filterFields.push({
                label: 'operaciones.linea',
                name: 'linea',
                as: 'selectlist',
                model: '',
                isDisabled: false,
                isRequired: false,
                items: this.maestrosLinea,
                multiple: false
            });
            this.filterFields.push({
                label: 'operaciones.codigo_estrategia',
                name: 'codigoEstrategia',
                as: 'number',
                model: '',
                isDisabled: false,
                isRequired: false
            });
            this.filterFields.push({
                label: 'operaciones.cantidad_desde',
                name: 'cantidadDesde',
                as: 'text',
                model: '',
                isDisabled: false,
                isRequired: false
            });
            this.filterFields.push({
                label: 'operaciones.cantidad_hasta',
                name: 'cantidadHasta',
                as: 'text',
                model: '',
                isDisabled: false,
                isRequired: false
            });
            this.filterFields.push({
                label: 'operaciones.fecha_desde',
                name: 'fechaDesde',
                as: 'date',
                model: '',
                isDisabled: false,
                isRequired: false
            });
            this.filterFields.push({
                label: 'operaciones.fecha_hasta',
                name: 'fechaHasta',
                as: 'date',
                model: '',
                isDisabled: false,
                isRequired: false
            });


            this.rulesForm["mesaId"] = [this.required()];
            this.rulesForm["productoId"] = [this.required()];
            this.rulesForm["codigoEstrategia"] = [this.required()];
            this.rulesForm["tipoId"] = [this.required()];
            this.rulesForm["cantidad"] = [this.minLen(1)];
            this.rulesForm["fechaEjecucion"] = [this.required()];
            this.rulesForm["linea"] = [this.required()];

            this.formFields  =  [
             this.mesaFormField,
            {
                label: 'operaciones.producto',
                name: 'productoId',
                as: 'selectlist',
                model: '',
                isDisabled: false,
                isRequired: true,
                items: this.maestroProductoEscritura,
                multiple: false,
                canView: true,
                cols: 4,
            },
            {
                label: 'operaciones.estrategia',
                name: 'codigoEstrategia',
                as: 'number',
                model: '',
                isDisabled: false,
                isRequired: true,
                canView: true,
                cols: 4,
            },
            {
                label: 'operaciones.tipo',
                name: 'tipoId',
                as: 'selectlist',
                model: '',
                isDisabled: false,
                isRequired: true,
                items: this.maestroOperacionTipo,
                multiple: false,
                canView: true,
                cols: 3,
            },
            {
                label: 'operaciones.cantidad_lotes',
                name: 'cantidad',
                as: 'number',
                model: '',
                isDisabled: false,
                isRequired: true,
                canView: true,
                cols: 3,
            },

              this.lineaFormField,
            {
                label: 'operaciones.fecha',
                name: 'fechaEjecucion',
                 as: 'date',
                model: '',
                isDisabled: false,
                isRequired: false,
                multiple: true,
                canView: true,
                cols: 3,
            }
        ];
            this.tableHeaders = [
            { text: 'operaciones.identificador', value: "id", sortable: true, as:'number' },
            this.mesaHeader,
            { text: 'operaciones.producto', value: "productoId", sortable: true, as: 'multiselect', items: this.maestroProducto},
            { text: 'operaciones.tipo', value: "tipoId", sortable: true, as: 'multiselect',
                 items: this.maestroOperacionTipo},
            { text: 'operaciones.linea', value: "linea", sortable: true, as: 'select',
                items: this.maestrosLinea },
            { text: 'operaciones.fecha', value: "fechaEjecucion", sortable: true, as: 'date' },
            { text: 'operaciones.estrategia', value: "codigoEstrategia", sortable: true, as: 'multiselect' },
            { text: 'operaciones.cantidad_lotes', value: "cantidad", sortable: true, as: 'number' },
            { text: 'operaciones.estado', value: "estadoId", sortable: true, as: 'multiselect',
                items: this.maestroOperacionEstado },
            { text: '', value: "actions", sortable: false, as:'', actions:[
                {icon: 'mdi-close', name: 'eliminar'},
                {icon: 'edit', name: 'editar'},
                {icon: 'visibility', name: 'ver'}
            ] },
        ] ;
        }

        async getOperacionesList(){
            this.openSpinner("operaciones.cargarListado");

            this.items = [];
            const filtro : any = {};
            this.filterFields.forEach(f =>{
              if(f.model){
                  filtro[f.name] = f.model;
              }
          });

          const page = this.tableOptions?.page ?? 1;
          const itemsPerPage = this.tableOptions?.itemsPerPage ?? 10;
          const sortBy = this.tableOptions?.sortBy ?? [];
          const sortDesc = this.tableOptions?.sortDesc ?? [];
          filtro.PageNumber = page || 1;
          filtro.PageSize = itemsPerPage || 10;

          if (sortBy && sortBy.length) {
            filtro.sortBy = sortBy[0];
            filtro.sortDesc = !!(sortDesc && sortDesc[0]);
          }

          const route = '/api/operacion/list';
          this.post({ apiUrl: route, entity: filtro })
          .then(data => {
                if(this.isAdminCEN || this.isMesaLect)
                {
                    (data.items || []).forEach(x => {x.actions.editar = false; x.actions.eliminar = false; x.actions.ver = false})
                }
                console.log(data.items);
            if (Array.isArray(data.items)) {
                this.items = data.items;
                this.totalItems = data.totalCount ?? 0;
            } else {
                this.items = data?.items ?? [];
                this.totalItems = data?.totalCount ?? 0;
            }
            })
            .catch(error =>{
                this.mostrarErrorOperacion(error, "operaciones.koListado");
            })
            .finally(() => {
                this.closeSpinner();
            });
        }

        async exportarOperaciones(){
            const filtro: any = {};

            this.filterFields.forEach(f => {
                if (f.model) {
                    filtro[f.name] = f.model;
                }
            });

            filtro.idioma = this.$i18n.locale;
            filtro.PageNumber = 1;
            filtro.PageSize = this.totalItems > 0 ? this.totalItems : 100000;

            const exportHeaders = this.tableHeaders
                .filter((header) => header.value !== 'actions' && !header.noExportable)
                .map((header) => ({
                    ...header,
                    text: this.t(header.text),
                }));

            this.openSpinner("operaciones.cargarListado");

            this.post({
                apiUrl: '/api/operacion/list',
                entity: filtro,
            })
            .then(data => {
                const rows = Array.isArray(data?.items)
                    ? data.items
                    : (Array.isArray(data) ? data : []);

                const excelData = [exportHeaders.map((header) => header.text)];

                rows.forEach((row) => {
                    const excelRow: string[] = [];
                    exportHeaders.forEach((header) => {
                        excelRow.push(this.formatExportValue(row[header.value], header.as, header.items));
                    });
                    excelData.push(excelRow);
                });

                return this.post({
                    apiUrl: `/api/excel/export?filename=${this.getExportFileName()}`,
                    entity: excelData,
                    array: true,
                });
            })
            .then(data => {
                const blob = new Blob(
                    [data],
                    { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
                );

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');

                link.href = url;
                link.setAttribute('download', `${this.getExportFileName()}.xlsx`);

                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch(() => {
                this.mostrarKO("operaciones.koListado");
            })
            .finally(() => {
                this.closeSpinner();
            });
        }

        private getExportFileName(): string {
            return this.$i18n.locale === 'en'
                ? 'Operations'
                : 'Operaciones';
        }

        private formatExportValue(value: any, type: string, items: any): string {
            if (value != null && value != undefined) {
                if (items) {
                    if (Array.isArray(value)) {
                        const names = value.map(v => this.formatSelectNombre(v, items));
                        return names.join('/ ');
                    }

                    const item = items.find(i => i.id == value);
                    if (item) {
                        return this.tUi(item.nombre);
                    }
                } else {
                    switch (type) {
                        case 'date':
                            return moment(value).format('DD/MM/YYYY');
                        case 'dateTime':
                            return moment(value).format('DD/MM/YYYY hh:mm');
                        default:
                            return this.tUi(String(value));
                    }
                }
            }

            return value;
        }

        private formatSelectNombre(id: any, items: any): string {
            if (!items) {
                return id;
            }

            for (let i = 0; i < items.length; i++) {
                if (items[i].id === id) {
                    return this.tUi(items[i].nombre);
                }
            }

            return this.tUi(id);
        }

        nuevoElemento() : void {
            this.popupHeaderText = "operaciones.nuevoElemento";
            this.itemEdit = { mesaId : this.userIdentity.mesaId};
            this.fechaEjecucionAnterior = null;
            this.productoAnterior = null;
            this.mesaAnterior = null;
            this.formOnlyRead = false;
            if (this.mesaFormField) {
               this.mesaFormField.items = this.maestroMesaEscritura;
            }
            const productoField = this.formFields.find(f => f.name === 'productoId');
            if (productoField) {
                productoField.items = this.maestroProductoEscritura;
            }

            if(!this.isContraParte){

                if(this.maestroMesaEscritura.length == 1){
                    this.itemEdit.mesaId = this.maestroMesaEscritura[0].id;
                    this.formFields[0].isDisabled = true;
                }else{
                    this.formFields[0].isDisabled = false;
                }
            }

            this.isOpenForm = true;
        }

        crearEstrategias(idEstrategia: number): void{

          const estrategiaParaEnviar = {
              idEstrategia: idEstrategia,
              crearDiarias: this.crearEstrategiaOperacion.crearDiarias
          };

          this.openSpinner("operaciones.cargar");
          this.post({ apiUrl: `/api/operacion/estrategia`, entity: estrategiaParaEnviar})
                          .then(() => {
                            this.closeSpinner();
                            this.mostrarOK("operaciones.creacionExitosa");
                              this.getOperacionesList();
                          })
                          .catch((error) => {
                              this.mostrarErrorOperacion(error, "operaciones.errorCreacion");
                              this.closeSpinner();
                          });
        }

        importarArchivo() : void {
            this.isOpenImportar = true;
        }

        tableEventAction(action:string, item:any): void{
            switch (action) {
                case 'eliminar':
                    this.itemEliminar = item;
                    this.showDialog = true;
                  break;
                case 'editar':
                    this.mesaFormField.items = this.maestroMesaEscritura;
                    this.popupHeaderText = "operaciones.editarElemento";
                    this.itemEdit = {};
                    this.fechaEjecucionAnterior = null;
                    this.productoAnterior = null;
                    this.mesaAnterior = null;
                    this.openSpinner("operaciones.cargar");

                    this.get({ apiUrl: `/api/operacion/${item.id}`})
                          .then((response) => {
                                this.itemEdit = response;
                                this.itemEdit["$item_id"] = item.id;
                                this.productoAnterior = this.itemEdit.productoId;
                                this.mesaAnterior = this.itemEdit.mesaId;
                                this.fechaEjecucionAnterior = this.itemEdit.fechaEjecucion;
                            this.closeSpinner();
                            this.isOpenForm = true;
                            this.formOnlyRead = false;
                          })
                                                    .catch((error) => {
                                                        this.mostrarErrorOperacion(error, "operaciones.errorCargar");
                            this.closeSpinner();
                      });

                    break;
                case 'ver':
                    this.mesaFormField.items = this.maestroMesaBase;
                    this.popupHeaderText = "operaciones.verElemento";
                        this.itemEdit = {};
                        this.openSpinner("operaciones.cargar");

                        this.get({ apiUrl: `/api/operacion/${item.id}`})
                            .then((response) => {
                                    this.itemEdit = response;
                                    this.itemEdit["$item_id"] = item.id;
                                    this.productoAnterior = this.itemEdit.productoId;
                                    this.mesaAnterior = this.itemEdit.mesaId;
                                    this.fechaEjecucionAnterior = this.itemEdit.fechaEjecucion;

                                this.closeSpinner();
                                this.isOpenForm = true;
                                this.formOnlyRead = true;
                            })
                            .catch((error) => {
                                this.mostrarErrorOperacion(error, "operaciones.errorCargar");
                                this.closeSpinner();
                      });
                    break;
                default:
                    break;
            }
        }

      private eliminarOperaciones() {

        this.showDialog = false;
        this.openSpinner("operaciones.eliminarExitosa");
        this.delete({ apiUrl: `/api/operacion`, entity: this.itemEliminar })
          .then(() => {
            // Manejar la respuesta si es necesario
            this.closeSpinner();
            this.mostrarOK("operaciones.eliminarExitosa");
            // Actualizar el listado después de la eliminación
            this.getOperacionesList();
          })
                    .catch((error) => {
            this.closeSpinner();
                        this.mostrarErrorOperacion(error, "operaciones.errorEliminar");
          });
      }

        formEventAction(action:string, item:any): void{
            switch (action) {
                case 'salvar':
                  if (item["$item_id"]) {
                       this.openSpinner("operaciones.actualizarElemento");
                      // Realizar la llamada a la API para actualizar el elemento
                      this.put({ apiUrl: `/api/operacion/${item["$item_id"]}`, entity: item })
                          .then(() => {
                              this.isOpenForm = false;
                              this.closeSpinner();
                              this.mostrarOK("operaciones.actualizacionExitosa");
                              this.getOperacionesList();
                          })
                          .catch((error) => {
                              this.mostrarErrorOperacion(error, "operaciones.errorActualizacion");
                              this.closeSpinner();
                          });
                  } else {
                      // Crear y listado
                      // Aquí realizamos la llamada a la API para crear un nuevo elemento
                      this.openSpinner("operaciones.crearElemento");
                      this.post({ apiUrl: '/api/operacion', entity: item })
                          .then(() => {
                              // Mostrar mensaje de éxito
                              this.isOpenForm = false;
                              this.closeSpinner();
                              this.mostrarOK("operaciones.creacionExitosa");
                              this.getOperacionesList();
                          })
                          .catch((error) => {
                              this.mostrarErrorOperacion(error, "operaciones.errorCreacion");
                              this.closeSpinner();
                          });
                  }
                  break;

                case 'cancelar':
                    this.isOpenForm = false;
                    break;
                case 'cambio':
                    if(item.estrategiaId > 0){
                        var estrategiaSeleccionada = this.maestroEstrategiaBase.find(me => me.id == item.estrategiaId);
                        if(estrategiaSeleccionada != undefined){
                            item.productoId = estrategiaSeleccionada.productoId;
                            item.codigoEstrategia = estrategiaSeleccionada.codigoEstrategia;
                            item.productoId = estrategiaSeleccionada.productoId;
                            item.tipoId = 'c';
                            var anioDesde = estrategiaSeleccionada.anioDesde;
                            var anioHasta = estrategiaSeleccionada.anioHasta;
                            var msg = this.$t('validations_form.estrategiaAnio', { anioDesde, anioHasta });
                            if(this.rulesForm["fechaEjecucion"]){
                                this.rulesForm["fechaEjecucion"].splice(0);
                                this.rulesForm["fechaEjecucion"].push(this.required());
                                this.rulesForm["fechaEjecucion"].push((field: string) => (!field || (new Date(field).getFullYear() >= anioDesde && (!anioHasta || new Date(field).getFullYear() <= anioHasta))) || msg);
                            }
                        }
                    }
                    var producto = this.maestroProducto.find(p => p.id == item.productoId);
                    var cantidad = item.cantidad;

                    if(producto != null && cantidad < producto.limiteInicial)
                    {
                                            this.mostrarAdvertencia(
                                                this.$t('validations_form.cantidadLimiteInicial', { limiteInicial: producto.limiteInicial }).toString()
                                            );
                    }

                    if (producto != null) {
                      if (this.rulesForm["cantidad"]) {
                        const limiteSuperior = producto.limiteSuperior;
                                                var msgLimiteSuperior = this.$t('validations_form.cantidadLimiteSuperior', { limiteSuperior }).toString();
                        this.rulesForm["cantidad"].push((field) => field <= limiteSuperior || msgLimiteSuperior);
                      }
                    }
                     if (item.productoId && item.fechaEjecucion) {
                        if(item.productoId != this.productoAnterior || item.fechaEjecucion != this.fechaEjecucionAnterior){
                            this.lineaFormField.isDisabled = true;
                            item.linea = null;
                            this.post({
                                apiUrl: `/api/operacion/linea/list`,
                                entity: { productoId: item.productoId, FechaOperacion: item.fechaEjecucion }
                            }).then((lineasResp: any) => {
                                // Accept either [] or { items: [] }
                                const lineas: any[] = Array.isArray(lineasResp)
                                    ? lineasResp
                                    : (Array.isArray(lineasResp?.items) ? lineasResp.items : []);
                                    this.lineaFormField.items = lineas;
                                    if (lineas.length > 0) {
                                    const fechaOperacion = new Date(item.fechaEjecucion);
                                    const lineaPorFecha = Number.isNaN(fechaOperacion.getTime())
                                        ? null
                                        : lineas.find((linea) => Number(linea.id) === fechaOperacion.getMonth() + 1);
                                    item.linea = lineaPorFecha ? lineaPorFecha.id : lineas[0].id;
                                        }
        }).catch(() => {
          // keep it usable even if request fails (or keep empty list)
          this.lineaFormField.items = [];
          item.linea = null;
        })
        .finally(() => {
          // re-enable for non-contraparte after loading (contraparte stays disabled)
          this.lineaFormField.isDisabled = this.isContraParte;
        });
    }
                    } else {
                        // Si no se cumplen las condiciones anteriores
                        this.lineaFormField.isDisabled = this.isContraParte;
                        item.linea = null;
                        this.lineaFormField.isDisabled = true;
                    }

                    // Mesa filtering when product is selected
                    if (item.productoId && item.productoId !== this.productoAnterior) {
                        this.post({
                            apiUrl: '/api/maestro/mesa/filtrado',
                            entity: { productoId: item.productoId }
                        }).then(mesasFiltradas => {
                            if (mesasFiltradas && Array.isArray(mesasFiltradas)) {
                                if (mesasFiltradas.length === 0) {
                                    this.mesaFormField.items = [{ id: -1, nombre: this.$i18n.t("productos.sinMesaDisponible").toString(), disabled: true }] as any;
                                    item.mesaId = null;
                                } else {
                                    this.mesaFormField.items = mesasFiltradas;
                                    if (item.mesaId && !mesasFiltradas.some(m => m.id === item.mesaId)) {
                                        item.mesaId = null;
                                    }
                                }
                            }
                        }).catch(() => {
                            this.mesaFormField.items = this.maestroMesaEscritura;
                        });

                        this.productoAnterior = item.productoId;
                    }

                    // Produto filtering when mesa is selected
                    if (item.mesaId && item.mesaId !== this.mesaAnterior) {
                        const productoFormField = this.formFields.find(f => f.name === 'productoId');

                        if (productoFormField) {
                            this.post({
                                apiUrl: '/api/maestro/producto/filtrado',
                                entity: { MesaId: item.mesaId }
                            }).then(productosFiltrados => {
                                if (productosFiltrados && Array.isArray(productosFiltrados)) {
                                    if (productosFiltrados.length === 0) {
                                        productoFormField.items = [{ id: -1, nombre: this.$i18n.t("productos.sinProductoDisponible").toString(), disabled: true }] as any;
                                        item.productoId = null;
                                        item.linea = null;
                                    } else {
                                        productoFormField.items = productosFiltrados;
                                        if (item.productoId && !productosFiltrados.some(p => p.id === item.productoId)) {
                                            item.productoId = null;
                                            item.linea = null;
                                        }
                                    }
                                }
                            }).catch(() => {
                                productoFormField.items = this.maestroProductoEscritura;
                            });
                        }
                    }

                    if (!item.mesaId && this.mesaAnterior) {
                        const productoFormField = this.formFields.find(f => f.name === 'productoId');
                        if (productoFormField) {
                            productoFormField.items = this.maestroProductoEscritura;
                        }
                    }

                    if (!item.productoId && this.productoAnterior) {
                        this.mesaFormField.items = this.maestroMesaEscritura;
                        this.productoAnterior = null;
                    }

                    this.productoAnterior = item.productoId;
                    this.mesaAnterior = item.mesaId;
                    this.fechaEjecucionAnterior = item.fechaEjecucion;
                    break;
                default:
                    break;
                }
              }


        importEventAction(action:string): void{
            this.getOperacionesList();
            this.isOpenImportar = false;
        }

        changeFilters(): void {
            this.filterChips.splice(0);
            this.filterFields.forEach(f =>{
                if(f.model){
                    if(Array.isArray(f.model)){
                        f.model.forEach(m =>{
                            this.filterChips.push({clave:`${f.name}-${m.id}`, valor:m.nombre, tooltip: f.label});
                        })
                    }
                    else
                    {
                        this.filterChips.push({clave:`${f.name}`, valor: f.model as string , tooltip: f.label});
                    }
                }
            });


            this.isOpenFilters = false;
            this.getOperacionesList();
        }

        removeChip(clave: string): void {
            if(clave){
                this.filterChips = this.filterChips.filter(c => c.clave != clave);

                var name = clave.split('-')[0];
                var field = this.filterFields.find(f => f.name == name);
                if(field){
                    if(Array.isArray(field.model)){
                        var id = clave.split('-')[1];
                        field.model = field.model.filter(m => m.id != id);
                    }
                    else
                    {
                        field.model = '';
                    }
                }
                this.getOperacionesList();
            }
        }

        private mostrarErrorOperacion(error: any, fallbackKey: string): void {
            const backendTitle = error?.backendTitle ?? error?.response?.data?.title;
            if (backendTitle) {
                this.$toast.error(this.tUi(String(backendTitle)));
                return;
            }

            this.mostrarKO(fallbackKey);
        }

        rulesForm = {

        };
    }

    export default OperacionesPage;
